export type Bonus = {
  number: string
  title: string
  body: string
  /** URL pública de la portada. Vacío = se muestra una portada diseñada de respaldo. */
  cover: string
  accent: string
}

/**
 * Los 5 bonus reales del pack (ficha DPS44 · Acro Yoga Class Ready, sección 6).
 * Los PDFs están en Drive > bonos (DPS44 - Bono 1..5). `cover` es el
 * mockup de cada bono.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Master Session Finder',
    body: 'Tell it who’s in the room, where you are and how long you have, and it points you to the right session in under a minute. All 60 sessions sorted by goal, level, group size, place and duration — plus four quick routes across volumes.',
    cover:
      'https://cdn.magicpatterns.com/uploads/2ieHUVPyzRLHjJEPLoNNZf/DPS44_-_Bono_1_-_Master_Session_Finder.png',
    accent: 'bg-coral',
  },
  {
    number: '02',
    title: 'Nervous Flyer Scripts',
    body: 'Word-for-word scripts for the student who freezes, the one who had a bad experience somewhere else, and the base who’s scared of dropping someone. Twelve one-to-one conversations, each with a Ground-lane option so nobody sits out.',
    cover:
      'https://cdn.magicpatterns.com/uploads/tL1UdmaHiuHfKdQeTmq1NL/DPS44_-_Bono_2_-_Nervous_Flyer_Scripts.png',
    accent: 'bg-fly',
  },
  {
    number: '03',
    title: 'Last-Minute Rescue Cards',
    body: '20 printable cards for the moments your plan falls apart: seven people show up, your spotter cancels, the room is half the size, it rains on the retreat lawn. Each with a 3-step fix and the session that solves it best.',
    cover:
      'https://cdn.magicpatterns.com/uploads/u3Aj2PnaUAkSoNmdbuCTpt/DPS44_-_Bono_3_-_Last-Minute_Rescue_Cards.png',
    accent: 'bg-saffron',
  },
  {
    number: '04',
    title: '5-Minute Start Guide',
    body: 'Your first class from this pack, ready tonight: what to print, what to set up, which session to teach first — with a starting route for acro teachers, yoga teachers, retreat hosts and jam facilitators.',
    cover:
      'https://cdn.magicpatterns.com/uploads/va6nx4qQEQC5xmWb6YVfdq/DPS44_-_Bono_4_-_5-Minute_Start_Guide.png',
    accent: 'bg-ground',
  },
  {
    number: '05',
    title: 'Incident Response Card & Log',
    body: 'A one-page card for the wall and a simple log: who to call, what to do with the rest of the room after a fall, and what to write down after. Organizational steps only — not first aid training or medical advice.',
    cover:
      'https://cdn.magicpatterns.com/uploads/5pL8KGmw3rDeXTLWak74gh/DPS44_-_Bono_5_-_Incident_Response_Card__Log.png',
    accent: 'bg-signal',
  },
]
